import React from 'react'
import {Card} from 'react-bootstrap'
import styles from './Author.module.css'

const Author = () => {
    return (
        <div id="Author" className="text-center p-5">
         <h1  style={{color:"#98426a"}}>
                Author & Book Samples
              </h1>
              <p className="lead">
                A quick overview for the writer's career and some samples to the unique techniques provided in <b className="text-dark"> "MR.MACK"</b>
              </p>
              <hr style={{width:"30%", margin:"0 auto"}}></hr>
        
              <div className= {styles.flex}>
            <Card className= {styles.flexItem}>

           <Card.Img variant="top" src="img/person1.jpg" className="img-fluid rounded-circle w-50 mb-3 m-auto" />
          <Card.Body>
          <Card.Title> <h3>Dalia Gadelhak</h3>
          </Card.Title>
          <Card.Text>
          <h5 className="text-muted">Lead Writer & Front-end developer</h5> 
        <p> <b className="text-dark">'Dalia Gadelhak'</b> is an innovative writer who gives high value to new ideas and details. She started her career as an English teacher and published "MR.MACK" in 2012. Then,she occupied different positions till 2014 when she changed her career to a front-end developer. And, she still seeks more!</p> 
        </Card.Text>
        </Card.Body>
        <div className="d-flex justify-content-center">
                  <div className="p-4">
                    <a href="http://facebook.com">
                      <i className="fab fa-facebook"></i>
                    </a>
                  </div>
                  <div className="p-4">
                    <a href="http://twitter.com">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </div>
                  <div className="p-4">
                    <a href="http://instagram.com">
                      <i className="fab fa-instagram"></i>
                    </a> 
                  </div>
                </div>
        </Card>
        
                
          <Card className= {styles.flexItem}>
          <h3 className="mt-5">Mind-map Sample</h3>
          <h5 className="text-muted mb-5"> Best way for new vocabulary</h5>
          <Card.Img variant="top" src="img/family2.jpg" />
          <Card.Body>
          
          </Card.Body>
          </Card>

          <Card className= {styles.flexItem}>
          <h3 className="mt-5">Grammar Sample</h3>
          <h5 className="text-muted mb-5">using a funny story</h5>
          <Card.Img variant="top" src="img/did2.jpg" />
          <Card.Body>
          
          </Card.Body>
          </Card>
                
        </div>
        </div>
    )
}

export default Author
